import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './langButton.css';

export default function LangButton() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleButtonRef = useRef(null);
  const firstOptionRef = useRef(null);

  const languages = [
    { code: 'ja', label: 'JP' },
    { code: 'en', label: 'EN' },
  ];

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setOpen(false);
    toggleButtonRef.current?.focus();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setOpen(false);
        toggleButtonRef.current?.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if (open) {
      firstOptionRef.current?.focus();
    }
  }, [open]);

  return (
    <div 
      className='lang-dropdown' 
      ref={dropdownRef}
    >
      <button
        ref={toggleButtonRef}
        className='lang-toggle'
        aria-haspopup='listbox'
        aria-controls='lang-menu'
        aria-expanded={open}
        aria-label={t('aria-label.lang-toggle')}
        onClick={() => setOpen(!open)}
      >
        {languages.find(l => l.code === i18n.language)?.label || i18n.language.toUpperCase()}
      </button>

      {open && (
        <ul
          id='lang-menu'
          className='lang-menu'
          role='listbox'
          aria-label={t('aria-label.lang-menu')}
        >
          {languages.map((lang, index) => (
            <li key={lang.code}>
              <button
                ref={index === 0 ? firstOptionRef : null}
                className={`lang-option ${i18n.language === lang.code ? 'active' : ''}`}
                role='option'
                aria-selected={i18n.language === lang.code}
                aria-current={i18n.language === lang.code ? 'true' : undefined}
                aria-label={t(`aria-label.select-${lang.code}`)}
                onClick={() => handleChangeLanguage(lang.code)}
              >
                {lang.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
